import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  email: string | null;
  paypalId: string | null;
  isAuthenticated: boolean;
  visitorId: string | null;
  adSource: string | null;
}

const initialState: UserState = {
  email: null,
  paypalId: null,
  isAuthenticated: false,
  visitorId: null,
  adSource: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setPaypalId: (state, action: PayloadAction<string>) => {
      state.paypalId = action.payload;
    },
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setVisitorId: (state, action: PayloadAction<string>) => {
      state.visitorId = action.payload;
    },
    setAdSource: (state, action: PayloadAction<string>) => {
      state.adSource = action.payload;
    },
    logout: (state) => {
      state.email = null;
      state.paypalId = null;
      state.isAuthenticated = false;
    },
  },
});

export const {
  setEmail,
  setPaypalId,
  setAuthenticated,
  setVisitorId,
  setAdSource,
  logout,
} = userSlice.actions;

export default userSlice.reducer;
